<div class="parts-filters-wrapper" [class.in-sidebar]="sidebar">
  <div class="quick-filters-header mb-16-px">
    <h4 class="mb-unset">Quick filters:</h4>
    <div class="actions">
      <!--
      <a pRipple class="more-filters">More filters</a>
      -->
      <a pRipple class="clear-filters" (click)="clearFilters()">Clear filters</a>
    </div>
  </div>
  <div class="row parts-filters-row" [class.pb-32-px]="!sidebar" [class.pb-16-md-px]="!sidebar"
    [class.mb-unset]="sidebar" [class.pb-unset]="sidebar">
    <div class="col-xl-12 col-lg-12 col-md-12">
      <div class="parts-filters" [class.mb-12-lg-px]="!sidebar">
        <form class="parts-filters-form" [formGroup]="filterControls">
          @for(filter of innerTopFilters; track filter.id){
          <app-dropdown-control [optionsSearchEnabled]="true"
            [disabled]="(loading$ | async) || filterOptions[filter.id]?.length === 0" [showClear]="true"
            [label]="filter.name" [options]="filterOptions[filter.id]" [control]="filterControls.controls[filter.id]"
            [name]="filter.code" [classess]="'mb-unset'" [lightMode]="sidebar" [loading]="loading$ | async">
          </app-dropdown-control>
          }
        </form>
      </div>
    </div>
  </div>
</div>
